import { render, staticRenderFns } from "./addsal.vue?vue&type=template&id=7b4c6356&scoped=true"
import script from "./addsal.vue?vue&type=script&lang=js"
export * from "./addsal.vue?vue&type=script&lang=js"
import style0 from "./addsal.vue?vue&type=style&index=0&id=7b4c6356&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4c6356",
  null
  
)

export default component.exports